export default __webpack_public_path__ + "static/media/leftPattern.33588740.svg";